import { render, staticRenderFns } from "./AgeWiseInsight.vue?vue&type=template&id=1b0816dd&"
import script from "./AgeWiseInsight.vue?vue&type=script&lang=js&"
export * from "./AgeWiseInsight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b0816dd')) {
      api.createRecord('1b0816dd', component.options)
    } else {
      api.reload('1b0816dd', component.options)
    }
    module.hot.accept("./AgeWiseInsight.vue?vue&type=template&id=1b0816dd&", function () {
      api.rerender('1b0816dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/NewReports/AgeWiseInsight.vue"
export default component.exports